import { Popup } from '@approvalmax/ui/src/components';
import { FC, memo, SyntheticEvent, useCallback, useState } from 'react';

import { Video } from './PopupContent.styles';
import { PopupContentProps } from './PopupContent.types';

export const PopupContent: FC<PopupContentProps> = memo((props) => {
    const { videoSrc, title, onWatchingCounted } = props;

    const [isWatchingCounted, setIsWatchingCounted] = useState(false);

    const handleTimeUpdate = useCallback(
        (event: SyntheticEvent<HTMLVideoElement, Event>) => {
            if (event.currentTarget.currentTime > 10) {
                setIsWatchingCounted(true);
                onWatchingCounted?.();
            }
        },
        [onWatchingCounted]
    );

    return (
        <>
            <Popup.Header title={title} />

            <Popup.Body>
                <Video controls onTimeUpdate={onWatchingCounted && !isWatchingCounted ? handleTimeUpdate : undefined}>
                    <source src={videoSrc} />
                </Video>
            </Popup.Body>
        </>
    );
});

PopupContent.displayName = 'PopupContent';
